export default "__VITE_ASSET__Di2rJ60l__"